import { render, staticRenderFns } from "./Estadisticas.vue?vue&type=template&id=10a84635&"
import script from "./Estadisticas.vue?vue&type=script&lang=js&"
export * from "./Estadisticas.vue?vue&type=script&lang=js&"
import style0 from "vue-slim-tabs/themes/default.css?vue&type=style&index=0&lang=css&"
import style1 from "./Estadisticas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports